import * as React from 'react';
import styled from 'styled-components';
import colors from '../colors';

const Blanket = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(10, 10, 15, 0.7);
  padding: 1.75rem 1rem;
  overflow: hidden;
  z-index: 9999;
`;

const Container = styled.div`
  max-width: 600px;
  margin: 2.5rem auto;
  background: #fff;
  border-radius: 0.2rem;
  overflow: hidden;
  position: relative;
  z-index: 10000;
`;

const CloseButton = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 1rem;
  height: 1rem;
  cursor: pointer;
  color: ${colors.gray700};
`;

const Content = styled.div`
  padding: 3rem 3rem;
  overflow-y: auto;
  max-height: calc(100vh);
`;

export interface Props {
  onClose?: () => void;
  closeMark?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const InfoModal: React.FunctionComponent<Props> = (props) => {
  const {onClose, children, closeMark = '✕', className = ''} = props;
  return (
    <Blanket className={className} onClick={onClose}>
      <Container
        onClick={(e) => {
          e.stopPropagation();
        }}
        className="modal-container"
      >
        {closeMark && (
          <CloseButton className="close-button" onClick={onClose}>
            {closeMark}
          </CloseButton>
        )}
        <Content className="modal-content">{children}</Content>
      </Container>
    </Blanket>
  );
};

export default InfoModal;
